import { Component, } from '@angular/core';
import {BaseComponent} from "../../views/base.component";
import {EventsService} from "../../lib/EventsService";
import {FilterFormService} from "../../views/filter_form/filter_form.service";
import {TranslateService} from "../../translate";
import {ActivatedRoute, Router} from "@angular/router";
import {ApiService} from "../api.service";
import {ChartParams} from "../../views/chart/chart.component";
import {EAStat} from "../../models/user";
import {FilterParams} from "../../models/filter_form.model";
import merge from "lodash-es/merge";
import * as qs from 'qs';

@Component({
  selector: 'app-perfomance',
  templateUrl: './perfomance.component.html'
})
export class PerfomanceComponent extends BaseComponent {
	public stats: EAStat[] = [];

	addFilterParams = {
		dateFilters: ['datePaid', 'dateCreated', 'dateSiteCreated', 'dateTo', 'datePublished'],
		isRegDay: true,
		userType: 'user',
		dateType: 'dateCreated'
	};

	chartData = new ChartParams();
	
	constructor(
		public eventsService: EventsService,
		public service: ApiService,
		public route: ActivatedRoute,
		public filter: FilterFormService,
		public translate: TranslateService,
		public router: Router
	) {
		super(eventsService, service, route, filter, translate);
	}
	
	
	async getData() {
		const me = this;
		
		me.isLoad = true;
		
		const fp = me.filter.getCopyFilterParams();
		fp.level = 'group';
		const { stats } = await me.service.perfomance.stats(fp).toPromise();
		me.stats = <EAStat[]>stats;
		
		me.isLoad = false;
	}
	
	
	// Возможно нам подзодит стандартный bootstrap-класс
	// https://getbootstrap.com/docs/4.0/utilities/spacing/
	// pl-4 и далее
	getRefererStyle(stat: EAStat) {
		if (stat.level === 'group') {
			return '';
		}
		
		if (stat.level === 'lang') {
			return 'pl-4';
		}
		
		return 'pl-5';
	}
	
	
	async showSource(stat: EAStat, i: number) {
		const me = this;
		
		if (stat.isOpened) {
			
			// close
			me.stats.splice(i + 1, stat.refs.length);
			
			stat.isOpened = false;
			
			return;
		}
		
		stat.isOpened = true;
		
		const fp = me.filter.getCopyFilterParams();
		
		let level = stat.level;
		switch (stat.level) {
			case 'group':
				fp.inGroup = stat.refGroup;
				level = 'lang';
				fp.level = level;
				
				break;
			case 'lang':
				fp.inGroup = stat.refGroup;
				fp.lang = stat.joinId;
				level = 'campaign';
				fp.level = level;
				
				break;
				
			default:
				
				break;
		}
		
		stat.isLoad = true;
		const { stats } = await me.service.perfomance.stats(fp).toPromise();
		stat.refs = stats.map(r => {
			r.level = level;
			
			return <EAStat>r;
		});
		
		stat.isLoad = false;
		
		me.stats = [
			...me.stats.slice(0, i + 1),
			...stat.refs.map(ref => {
				ref.inGroup = stat.refGroup;
				
				return ref;
			}),
			...me.stats.slice(i + 1)
		];
	}

	async applyFilters() {
		let params = this.filter.getApplyFilters(this.filter.filterParams),
			url    = this.router.url.split('?')[0];

		params = qs.stringify(params, { encode: false });

		this.router.navigateByUrl(`${url}?${params}`, { relativeTo: this.route });
	}


	async resetFilters() {
		this.filter.filterParams = new FilterParams();
		this.filter.filterParams = merge({}, this.filter.filterParams, this.filter.addFilterParams);
		this.filter.filterParams.dateFilterParams = this.filter.getDateFilterParams(this.filter.filterParams, this.filter.addFilterParams);

		let params: FilterParams = merge({}, this.filter.getDiffParams(this.filter.filterParams)),
			url = this.router.url.split('?')[0];

		delete params.dateFilters;
		delete params.dateFilterParams;

		this.router.navigate([url], { relativeTo: this.route, queryParams: params });
	}
}
